import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export const Proof = () => {
  return <section className="py-24 bg-wellness-cream-dark relative" data-id="element-119">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-wellness-sage/20 text-center relative" data-id="element-121">
          <Quote className="w-12 h-12 text-wellness-sage/30 absolute top-8 left-8 md:top-12 md:left-12" data-id="element-122" />

          <p className="text-2xl md:text-3xl font-serif leading-relaxed text-wellness-forest mb-8 relative z-10 pt-6" data-id="element-123">
            "In just the first 72 hours of lowering cellular inflammation, most
            women report a physical{' '}
            <span className="italic text-wellness-gold-dark" data-id="element-124">'tightening'</span>{' '}
            of the waistline and the disappearance of the late-night puffiness
            that usually makes their shoes feel tight."
          </p>

          <div className="flex items-center justify-center gap-4" data-id="element-125">
            <div className="w-12 h-[1px] bg-wellness-sage" data-id="element-126"></div>
            <span className="font-sans text-sm tracking-widest uppercase text-wellness-forest/60" data-id="element-127">
              Clinical Observation
            </span>
            <div className="w-12 h-[1px] bg-wellness-sage" data-id="element-128"></div>
          </div>
        </motion.div>
      </div>
    </section>;
};